export default "__VITE_ASSET__f82c6c40__"